import Choices from 'choices.js';

const bindEvents = component => {
    component.instances.forEach(tabs => {
        tabs.querySelectorAll(component.selectors().tabItem).forEach(tabItem => {
            tabItem.addEventListener('click', ev => {
                ev.preventDefault();
                if (!tabItem.classList.contains(component.classNames.tabItemActive)) {
                    component.resetActive(tabs);
                    component.show(tabs, tabItem);
                }
            });
        });
    });
};

const bindMobileEvents = (component, instance, mobileSelectChoices) => {
    const tabItems = instance.querySelectorAll(component.selectors().tabItem);
    tabItems.forEach(tabItem => {
        tabItem.addEventListener('click', ev => {
            ev.preventDefault();
            mobileSelectChoices.setChoiceByValue(tabItem.dataset.tabsOpen);
        });
    });
};

const Tabs = {
    classNames: {
        tabs: 'tabs',
        tabItem: 'tabs__navigation__item',
        tabItemActive: 'tabs__navigation__item--active',
        tabContent: 'tabs__content',
        tabContentActive: 'tabs__content--active',
        // select
        mobileSelect: 'tabs__navigation-mobile',
        mobileSelectItem: 'tabs__navigation-mobile__item'
    },
    selectors() {
        return {
            tabs: `.${this.classNames.tabs}`,
            tabItem: `.${this.classNames.tabItem}`,
            tabItemActive: `.${this.classNames.tabItemActive}`,
            tabContentActive: `.${this.classNames.tabContentActive}`,
            mobileSelect: `.${this.classNames.mobileSelect}`,
            mobileSelectItem: `.${this.classNames.mobileSelectItem}`,
            tabContent: tabId => `[data-tabs-content="${tabId}"]`
        };
    },
    resetActive(instance) {
        const activeTabItem = instance.querySelector(this.selectors().tabItemActive);
        const activeContent = instance.querySelector(this.selectors().tabContentActive);

        if (activeTabItem) {
            activeTabItem.classList.remove(this.classNames.tabItemActive);
        }

        if (activeContent) {
            activeContent.classList.remove(this.classNames.tabContentActive);
        }
    },
    show(instance, tabItem) {
        const tabId = tabItem.dataset.tabsOpen;
        const tabContentElement = instance.querySelector(this.selectors().tabContent(tabId));
        if (tabContentElement) {
            tabContentElement.classList.add(this.classNames.tabContentActive);
            tabItem.classList.add(this.classNames.tabItemActive);
        }
    },
    mobileShow(instance, id) {
        const tabContentElement = instance.querySelector(this.selectors().tabContent(id));
        const tabItem = instance.querySelector(`[data-tabs-open="${id}"]`);
        if (tabContentElement && tabItem) {
            tabContentElement.classList.add(this.classNames.tabContentActive);
            tabItem.classList.add(this.classNames.tabItemActive);
        }
    },
    instances: [],
    createMobileDropdowns() {
        this.instances.forEach(instance => {
            const mobileSelect = instance.querySelector(this.selectors().mobileSelect);
            const mobileSelectChoices = new Choices(
                instance.querySelector(this.selectors().mobileSelect),
                {
                    searchEnabled: false,
                    itemSelectText: '',
                    shouldSort: false
                }
            );
            mobileSelect.addEventListener('change', ev => {
                ev.preventDefault();
                this.resetActive(instance);
                this.mobileShow(instance, ev.detail.value);
            });

            bindMobileEvents(this, instance, mobileSelectChoices);
            return mobileSelectChoices;
        });
    },
    init() {
        this.instances = document.querySelectorAll(this.selectors().tabs);

        // create mobile dropdowns.
        this.createMobileDropdowns();

        // bindEvents to instances.
        bindEvents(this);
    }
};

export default Tabs;
